import * as Sentry from "@sentry/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import AppData from "./AppData";
import { AppDataProvider } from "./AppDataContext";
import LoginRedirect from "./auth/LoginRedirect";
import RedirectToDashboard from "./auth/RedirectToDashboard";
import SiteRedirect from "./auth/SiteRedirect";
import Dashboard from "./routes/dashboard";
import ErrorElement from "./routes/ErrorElement";
import SitePvReportPage from "./routes/SitePvReportPage";
import SiteView from "./routes/SiteView";
import SpvView from "./routes/SpvView";
import SurveyPage from "./routes/SurveyPage";
import TrackPageView from "./TrackPageView";
import TooNarrow from "./views/TooNarrow";

interface Route {
  path: string;
  component: React.ComponentType;
}

const routes: Route[] = [
  {
    path: "/org/:orgId/dashboard",
    component: Dashboard,
  },
  {
    path: "/org/:orgId/marketplace",
    component: Dashboard,
  },
  {
    path: "/org/:orgId/sites/:siteType",
    component: Dashboard,
  },
  {
    path: "/org/:orgId/add-site",
    component: Dashboard,
  },
  {
    path: "/org/:orgId/spv/:spvId",
    component: SpvView,
  },
  {
    path: "/org/:orgId/spv/:spvId/:currentTab",
    component: SpvView,
  },
  {
    path: "/org/:orgId/site/:siteId/pvreport",
    component: SitePvReportPage,
  },
  {
    path: "/org/:orgId/site/:siteId",
    component: SiteView,
  },
  {
    path: "/org/:orgId/site/:siteId/:currentTab",
    component: SiteView,
  },
  {
    path: "/site/:siteId",
    component: SiteRedirect,
  },
  {
    path: "/login-redirect",
    component: LoginRedirect,
  },
  {
    path: "/survey/:slug",
    component: SurveyPage,
  },
  {
    path: "*",
    component: RedirectToDashboard,
  },
];

const sentryCreateBrowserRouter = import.meta.env.PROD
  ? Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
  : createBrowserRouter;

const router = sentryCreateBrowserRouter(
  routes.map((route) => {
    if (route.path === "/login-redirect" || route.path === "/survey/:slug") {
      return {
        path: route.path,
        element: <route.component />,
      };
    }
    return {
      path: route.path,
      element: (
        <AppDataProvider>
          <AppData>
            <TrackPageView>
              <TooNarrow>
                <route.component />
              </TooNarrow>
            </TrackPageView>
          </AppData>
        </AppDataProvider>
      ),
      errorElement: <ErrorElement />,
    };
  })
);

const AppRoutes = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;
